// We need the RGB here due to the opacity being applied to the color in the chart component
export const TEAL_COLOR_WITH_OPACITY = 'rgb(11, 165, 139, 0.2)';
